import { jsx as _jsx } from "react/jsx-runtime";
var MinimizeIcon = function (props) { return (_jsx("svg", { width: props.width, height: props.height, viewBox: "0 0 24 24", fill: props.color, stroke: props.color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("line", { x1: "6", y1: "12", x2: "18", y2: "12" }) })); };
export default MinimizeIcon;
